module.exports = __webpack_public_path__ + "static/logo-convaise-a8c91f663d5d6c47957df0e01a791ddc.svg";